import { IFingerprintDTO } from '../../../../../../motw_core/DTOs/fingerprint';
export const defaultFingerprint: IFingerprintDTO = {
    providedFingerprint: "",
    isFingerprinted: false,
    fingerprintDetails: undefined
};
